import BaseService from './BaseService'
class CustomMenuLinkService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  getCustomMenuLink = (companyId:string, skip: number, limit: number, locationId?: string) =>{
    if(locationId) {
      return this.requests.get(`/?companyId=${companyId}&locationId=${locationId}&skip=${skip}&limit=${limit}`)
    }
    return this.requests.get(`/?companyId=${companyId}&showOnCompany=true&skip=${skip}&limit=${limit}`)
  }
  getCustomMenuLinkById = (companyId: string, customMenuLinkId: string, locationId?: string) => {
    if(locationId) {
      return this.requests.get(`/${customMenuLinkId}?companyId=${companyId}&locationId=${locationId}`)
    } else {
      return this.requests.get(`/${customMenuLinkId}?companyId=${companyId}`)
    }
  }
}

const customMenuLinkService = new CustomMenuLinkService(
    BaseService.servicesConfig.CustomMenuLinks as string
  )
export default customMenuLinkService